import { useState, useEffect, useCallback } from 'react';

let evtTarget;

try {
  evtTarget = new EventTarget();
} catch {
  evtTarget = document.createElement?.('phony');
}

const useStorage = (storage, key, defaultValue) => {
  const raw = storage.getItem(key);

  const [value, setValue] = useState(raw ? JSON.parse(raw) : defaultValue);

  const updater = useCallback(
    (updatedValue, remove = false) => {
      setValue(updatedValue);
      storage[remove ? 'removeItem' : 'setItem'](
        key,
        JSON.stringify(updatedValue)
      );
      evtTarget.dispatchEvent(
        new CustomEvent('storage_change', { detail: { key } })
      );
    },
    [key]
  );

  if (defaultValue != null && !raw) updater(defaultValue);

  useEffect(() => {
    const listener = ({ detail }) => {
      if (detail.key === key) {
        const lraw = storage.getItem(key);

        if (lraw !== raw) setValue(JSON.parse(lraw));
      }
    };

    evtTarget.addEventListener('storage_change', listener);
    return () => evtTarget.removeEventListener('storage_change', listener);
  }, []);

  return { value, setValue: updater, removeValue: () => updater(null, true) };
};

export const useLocalStorage = (key, defaultValue) => {
  return useStorage(localStorage, key, defaultValue);
};
export const useSessionStorage = (key, defaultValue) => {
  return useStorage(sessionStorage, key, defaultValue);
};
